import { DestroyRef, Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { skip } from 'rxjs';
import { PermissionService } from '../../core/services/permission.service';

// Mostra o bloco (e habilita o form) só com a permissão EFETIVA: teto do Keycloak cruzado com o
// perfil de acesso do usuário no grupo da empresa ativa. Redesenha quando ela muda.
@Directive({
  selector: '[appHasPermission]',
  standalone: true
})
export class HasPermissionDirective {
  private readonly permissions = inject(PermissionService);

  private roles: string[] = [];
  private form?: FormGroup;
  private hasView = false;

  @Input() set appHasPermission(value: string | string[] | null | undefined) {
    this.roles = this.normalizeRoles(value);
    this.updateView();
  }

  @Input() set appHasPermissionFormGroup(value: FormGroup | undefined) {
    this.form = value;
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
  ) {
    // skip(1): o valor atual do BehaviorSubject chegaria antes do input e criaria a view sem roles.
    this.permissions.changes$
      .pipe(skip(1), takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(() => this.updateView());
  }

  private updateView(): void {
    if (this.permissions.hasAny(this.roles)) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }

      this.form?.enable({ emitEvent: false });
      return;
    }

    this.viewContainer.clear();
    this.hasView = false;
    this.form?.disable({ emitEvent: false });
  }

  private normalizeRoles(value: string | string[] | null | undefined): string[] {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  }
}
